<template>
  <div>
    <!--     <div slot="header">
      <span class="h5"><span class="fa fa-chart-line mr-2"></span>{{ $t('home.dashboard.static') }}</span>
    </div> -->
    <!-- <div slot="formBody"> -->
    <b-row align-v="center" class="justify-content-md-center px-2 py-1 m-1 mb-3 bordered rounded bg-light">
      <b-col cols="8">
        <b-row>
          <b-col cols="6">
            <FITDatePicker :width="inputWidth" v-model="form.startDate" :label="$t('home.dashboard.startDate')"></FITDatePicker>
          </b-col>
          <b-col cols="6">
            <FITDatePicker :width="inputWidth" v-model="form.endDate" :label="$t('home.dashboard.endDate')"></FITDatePicker>
          </b-col>
          <b-col cols="6">
            <FITSelect :width="inputWidth" :options="[{ text: 'General Insurance Policy', value: 'G' }, { text: 'Life Policy', value: 'P' }]" v-model="form.type" :label="$t('home.dashboard.policyType')"></FITSelect>
          </b-col>
          <b-col cols="6">
            <FITAutoSearch v-if="permissionLevel == 4" :label="$t('home.dashboard.agent')" :width="inputWidth" @resultKeyOutput="onResultKeyOutput" resultKey="ID" dest="option" v-bind="agentAutoSearchParams"></FITAutoSearch>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="auto">
        <FITButton variant="primary" :text="$t('home.dashboard.search')" @click="search" faIcon="fa-search"></FITButton>
      </b-col>
    </b-row>
    <FITFormCard v-for="data, idx in chartData" v-if="permissionLevel < data.accessLevel">
      <div slot="header">
        <span class="h5"><span class="fa mr-2" :class="`fa-chart-${data.type}`"></span>{{ $t(`home.dashboard.chart.${data.key}`) }}</span>
      </div>
      <div slot="formBody">
        <b-row align-v="center" align-h="center" class="text-center">
          <b-col cols="6">
            <div v-if="data.rawData.length == 0">{{$t('home.dashboard.chart.noData')}}</div>
            <b-table hover outlined bordered responsive head-variant="light" small :items="data.rawData"></b-table>
          </b-col>
          <b-col cols="6">
            <LineChart :height="200" ref="charts" v-if="data.type === 'line'" :chartData="data.data"></LineChart>
            <BarChart :height="200" ref="charts" v-else-if="data.type === 'bar'" :chartData="data.data"></BarChart>
            <!-- <br/> -->
            <!-- <b-table hover small outlined :items="data.rawData"></b-table> -->
          </b-col>
        </b-row>
      </div>
    </FITFormCard>
  </div>
  <!-- </FITFormCard> -->
</template>
<script type="text/javascript">
import Vue from 'vue'
import VueCharts from 'vue-chartjs'
import { Bar, Line } from 'vue-chartjs'

import LineChart from './LineChart'
import BarChart from './BarChart'

import moment from 'moment'

import {
  FITFormCard,
  FITDatePicker,
  FITButton,
  FITSelect,
  FITAutoSearch
} from '@/components'

export default {
  name: 'SearchableChart',
  components: {
    FITFormCard,
    FITDatePicker,
    FITSelect,
    FITButton,
    LineChart,
    BarChart,
    FITAutoSearch
  },
  props: {
    convertToChartData: {
      type: Function,
      required: true
    },
    charts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      form: {
        startDate: moment().subtract(12, 'month').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        type: 'P',
        // agentID: 0,
        count: 10
      },
      chartData: [{ data: null }, { data: null }, { data: null }, { data: null }, { data: null }, { data: null }],
      // charts: [
      //   'casesTrend',
      //   'fycTrend',
      //   'casesByProvider',
      //   'commissionByProvider',
      //   'commissionByAgent',
      //   'fycByAgent',
      //   'commissionTrend'
      // ],
      agentAutoSearchParams: {
        placeholder: 'Type to search',
        dest: 'option',
        paras: [{ key: 'type', value: 'agent' }],
        showItems: ['englishFullname', 'chineseFullname', 'agentCode'],
      },
    }
  },

  computed: {
    permissionLevel() {
      return this.$store.state.permissionLevel;
    },
    param() {
      let cpy = JSON.parse(JSON.stringify(this.form));
      cpy['startDate'] = moment(cpy['startDate']).format('YYYY-MM');
      cpy['endDate'] = moment(cpy['endDate']).format('YYYY-MM');
      return cpy;
    },
    inputWidth() {
      return 9
    }
  },
  watch: {
    selectedAgent(newData, oldData) {
      console.debug(newData);
      Vue.set(this.form, 'agentID', newData.ID);
    }
  },
  mounted() {
    this.search();
  },
  methods: {
    onResultKeyOutput(input) {
      Vue.set(this.form, 'agentID', input);
    },
    search() {
      Vue.set(this, 'chartData', [{ data: null }, { data: null }, { data: null }, { data: null }, { data: null }, { data: null }]);
      this.$store.dispatch('Homepage/getDashboardCharts', this.param)
        .then((data) => {

          // 
          let type = this.charts[0];
          var casesTrend = this.convertToChartData(data[type], type, 'cases', 'date', this.form.startDate, this.form.endDate, true);
          casesTrend = { type: 'line', data: casesTrend, key: 'casesTrend', rawData: data[type], accessLevel: 6.5 }

          // 
          type = this.charts[1];
          var fycTrend = this.convertToChartData(data[type], type, 'commission', 'date', this.form.startDate, this.form.endDate, true);
          fycTrend = { type: 'line', data: fycTrend, key: 'fycTrend', rawData: data[type], accessLevel: 6.5 }

          // 
          type = this.charts[2];
          var casesByProvider = this.convertToChartData(data[type], type, 'cases', 'providerCode', this.form.startDate, this.form.endDate);
          casesByProvider = { type: 'bar', data: casesByProvider, key: 'casesByProvider', rawData: data[type], accessLevel: 3.5 }

          //
          type = this.charts[3];
          var commissionByProvider = this.convertToChartData(data[type], type, 'commission', 'providerCode', this.form.startDate, this.form.endDate);
          commissionByProvider = { type: 'bar', data: commissionByProvider, key: 'commissionByProvider', rawData: data[type], accessLevel: 3.5 }

          //
          type = this.charts[4];
          var commissionByAgent = this.convertToChartData(data[type], type, 'commission', 'agentCode', this.form.startDate, this.form.endDate);
          commissionByAgent = { type: 'bar', data: commissionByAgent, key: 'commissionByAgent', rawData: data[type], accessLevel: 3.5 }

          //
          type = this.charts[5];
          var fycByAgent = this.convertToChartData(data[type], type, 'fyc', 'agentCode', this.form.startDate, this.form.endDate);
          fycByAgent = { type: 'bar', data: fycByAgent, key: 'fycByAgent', rawData: data[type], accessLevel: 3.5 }

          //
          type = this.charts[6];
          var commissionTrend = this.convertToChartData(data[type], type, 'commission', 'date', this.form.startDate, this.form.endDate, true);
          commissionTrend = { type: 'line', data: commissionTrend, key: 'commissionTrend', rawData: data[type], accessLevel: 6.5 }

          //
          let result = [casesByProvider, commissionByProvider, commissionByAgent, fycByAgent, casesTrend, fycTrend, commissionTrend] 
          Vue.set(this, 'chartData', result);

          this.$nextTick(() => {
            this.$refs.charts.forEach((chart) => {
              chart.render()
            });
          })
        });
    },

  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/Chart/SearchableChart.vue